import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter, ElementRef, ViewChild, ViewEncapsulation, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm, FormArray, FormControl } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import{ MatIconModule} from '@angular/material/icon';

import * as jwt_decode from "jwt-decode";
import { UserService } from './../../../../services/user.service';
import { LoginService } from './../../../../services/login.service';
import { TokenStorageService } from './../../../../services/token-storage.service';
import {Location} from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { PasswordTest } from '../password-strength/password-test.model';
import { PasswordStrength } from '../password-strength/password-strength.enum';
import { Identifiers } from '@angular/compiler/src/render3/r3_identifiers';
import { StrengthIndicatorComponent} from '../password-strength/strength-indicator.component';

//import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
declare var $: any;
export class ConfirmPasswordValidation {
  static MatchPassword(AC: AbstractControl) {
    if(!AC.get('newPassword')||!AC.get('confirmPassword')) {
      return null;
    }

    let password = AC.get('newPassword').value; // to get value in input tag
    let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if(password != confirmPassword) {
      AC.get('confirmPassword').setErrors( {MatchPassword: true} )
    } else {
      AC.get('confirmPassword').setErrors( null )
      return null
    }
  }
}

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss'],
 // encapsulation: ViewEncapsulation.None
})

export class ChangePasswordDialogComponent implements OnInit {
  showTick: boolean = false;
  failureTick: boolean=false;
  showInfo: boolean = false;
  public authDecoded: any;
  public userId: any;
  public userEmail: any = "";
  public loginId: any;
  hideOld: boolean = true;
  hideNew: boolean = true;
  hideConfirm: boolean = true;
  public changePasswordForm: FormGroup;
  @ViewChild('tooltip') tooltip;
  private user: any;
  roles: any[];
  public loggedInUserId: any;
  public reg = '(?!.* )(?=.{8,})(?=.*?[^\w\s])(?=.*?[#?!@$%^&*.-])(?=.*?)(?=.*?[A-Z]).*?[a-z].*'


  public Password_Criteria = `1. Must be at least 8 characters long
  2. Must contain one Upper and one Lower case alphabetic characters
  3. Must contain one special character
  4. New password must not match any of the previous 12 passwords
  5. Must not be the same as User ID’s `

  // showDelay = new FormControl(0);
  // hideDelay = new FormControl(4000);

  private readonly notifier: NotifierService;
  public hideTooltip: boolean = false;

  public showForm: boolean = true;
  public loggedInEmail: any;
  strength: PasswordTest;
  showPasswordRules: boolean = false;
  showGoodPassword: boolean = false;
  @Input()  isLoggedIn :any;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    public notifierService: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private login: LoginService,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private token: TokenStorageService,
		private _location: Location
    
  ) {
      if((JSON.parse(localStorage.getItem('loggedInUser')))){
      this.authDecoded = jwt_decode(localStorage.getItem('AuthorizationD'));
      this.userId = this.authDecoded.userPayload.userId;
      this.userEmail = this.authDecoded.userPayload.email;
     


      this.changePasswordForm = this.fb.group({
        oldPassword: ['', Validators.required],
        newPassword: ['', [Validators.required, this.noUserIDs,Validators.pattern(this.reg)]],
        confirmPassword: ['', Validators.required],
        notInUse:[]
      }, {
        validator: ConfirmPasswordValidation.MatchPassword // your validation method
      });
    }
    else{
    this.changePasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, this.noUserIDs,Validators.pattern(this.reg)]],
      oldPassword: [''],
      confirmPassword: ['', Validators.required],
      notInUse:[]
    }, {
      validator: ConfirmPasswordValidation.MatchPassword // your validation method
    });
    }
    if(this.isLoggedIn){

      this.loggedInUserId  = this.userId;

      if ((!this.loggedInUserId)) {
      this.login.logout().then(data => {
       this.clearSession();

        this.router.navigate(['/login']);
      },
      error => {

      });
      }
    }
     this.notifier = notifierService;

  }

  ngOnInit() {
    
  }

  noUserIDs(control: FormControl) {
    let value = control.value.match(/[\w-]+@([\w-]+\.)+[\w-]+/g)
    return !value ? null : {'sameAsUserId': true}
  }

  onFormSubmit(form:NgForm,data)
  {
    this.notifier.hide("changePass");
    if (this.changePasswordForm.invalid) {
      // this.notifierService.notify('error', 'Please fill required field!');
    } else {
      let userData = {};
      let id="";
     if(this.isLoggedIn==true){
      userData['oldPassword'] = form['oldPassword'];
      userData['newPassword'] = form['newPassword'];
    
      id=this.userEmail;
      
     }
     else{
      userData['confirmPassword'] = form['newPassword'];
      userData['password'] = form['newPassword'];
      this.route.queryParams
      .subscribe(params => {
        id = params.id;
        userData['changePasswordLinkKey']=id;
      }
    );

     }

      this.userService.changePassword(id, userData,this.isLoggedIn).
      then(resp => {
        if (resp) {
          if(this.isLoggedIn==true ){
          if((JSON.parse(localStorage.getItem('loggedInUser'))))
          {
          localStorage.setItem('setPassword','false');
          if(localStorage.getItem("enableDashboard") == "true"){
          this.router.navigate(['/home/dashboard']);
          }else{
            if(localStorage.getItem("defaultView") == null)
            {
            localStorage.setItem("defaultView","sender");
            }
          this.router.navigate(['/home/invoices']); }
        }



        }
        this.notifier.hide('0');
        this.notifier.getConfig().behaviour.autoHide = 5000;
        this.notifier.notify('success', 'Password Changed Successfully');
        //this.showTick=true;
        this.router.navigate(['/login']);
      }
      else{
        this.showTick=true;
        this.showForm=false;
        this.notifier.hide('0');
      }
    }).catch(error => {

      if(this.isLoggedIn==true)
      {
        this.notifier.hide('0');
        this.notifier.getConfig().behaviour.autoHide = false;
        setTimeout(() => {
        this.notifier.notify('error', 'Failed! Please try again later!',"changePass");
        }, 1000);
        if(error.apierror!=undefined) {

          this.notifier.hide('0');
          if(typeof(data) == "string") {
            this.notifier.getConfig().behaviour.autoHide = false;
            setTimeout(() => {
            this.notifier.notify('error', `Failed! ${data}`,"changePass");
          }, 1000);
          }
          else


          this.notifier.getConfig().behaviour.autoHide = false;
          setTimeout(() => {
          this.notifier.notify('error', error.apierror.message,"changePass");
        }, 1000);
          return false;
      }}
      else{
        this.showForm=false;
        this.failureTick=true;
        this.notifier.hide('0');
      }

    })


  }



}

  closeDialog(){

    if(this.isLoggedIn==true && !(localStorage.getItem("setPassword") != null &&
    localStorage.getItem("setPassword") == 'true')){
      if(localStorage.getItem("enableDashboard") == "true"){
        this.router.navigate(['/home/dashboard']);
      }else{
        if(localStorage.getItem("defaultView") == null){
        localStorage.setItem("defaultView","sender");
        }
         this.router.navigate(['/home/invoices']); }
    }
    else
    {
    this.router.navigate(['/login']);
    }
  }
  redirectLink(link){
    this.router.navigate(['/'+link]);
  }
  clearSession(){
		localStorage.removeItem('AuthorizationD');
				localStorage.removeItem('JSESSIONID');
				localStorage.removeItem('token');
				localStorage.removeItem('expires_at');
				localStorage.removeItem('selectedTile');
				localStorage.removeItem('widgets');
				localStorage.removeItem('loggedInUser');
				localStorage.removeItem('userId');
                localStorage.removeItem('setPassword');
		  this.token.signOut();

	}

  getStrength(data) {

    this.strength=data;

    if (data.strength != 4 ){
    if(data.clearedValidations==1){

     if(this.isLoggedIn==true){
      $('.passError2').attr('style',"margin-top:-36.5%;margin-left :69.8%");
      }
      else{
       $('.passError2').attr('style',"margin-top:-37.2%;margin-left :70.3%");
      }

    }

    else if(data.clearedValidations==2){
      if(this.isLoggedIn==true){
        $('.passError2').attr('style',"margin-top:-34.6%;margin-left :70.3%");
        }
        else{
          $('.passError2').attr('style',"margin-top:-35.5%;margin-left :69.8%");
        }



    }
    else if(data.clearedValidations==3){
      if(this.isLoggedIn==true){
        $('.passError2').attr('style',"margin-top:-28.3%;margin-left :69.8%");
        }
        else{

          $('.passError2').attr('style',"margin-top:-29%;margin-left :70.3%");
        }


    }

    else {
      if(this.isLoggedIn==true){
        $('.passError2').attr('style',"margin-top:-26.1%;margin-left :69.8%");
        }
        else{
          $('.passError2').attr('style',"margin-top:-27%;margin-left :70.3%");
        }

    }
    }
    this.cd.detectChanges();
 return this.strength;
  }

  updateRules() {
    if (this.changePasswordForm.controls.newPassword.valid) {
      this.showPasswordRules = false;
      this.showGoodPassword = false;
      setTimeout(() => {
        this.showGoodPassword = false;
      }, 500);
    }
    else {

      this.showGoodPassword = false;
      this.showPasswordRules = true;
    }
  }

}
